var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 5",
    d: "M15.9565 7.72231C17.3478 8.51239 17.3478 10.4876 15.9565 11.2777L8.13043 15.7219C6.73913 16.512 5 15.5244 5 13.9442L5 5.05576C5 3.47559 6.73913 2.48799 8.13043 3.27807L15.9565 7.72231Z",
    fill: "#013380"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.00612f1ef53307efeb46ea17222408bf.svg";
export { ForwardRef as ReactComponent };